/**
 * Statusse der Änderungen an Kundendaten
 *  */ 
export enum userDataChangesState {
    accepted = "A",
    refused = "R",
    pending = "P"
}